import { DotsHorizontalIcon } from "@heroicons/react/solid";
import { Markup } from "interweave";
import { React, useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ShowMoreText from "react-show-more-text";
import noImage from "../../Assets/Images/settings/no-image.png";
import moment from "moment";
import "../../components/CSS/Home/Post.css";
import "../../components/CSS/Sidebar/Left/Enroll.css";
import axios from "axios";
import swal from "sweetalert";
import ReactPlayer from "react-player";

import PostReaction from "./PostReaction";
import { serverInfo } from "../../App";
import { LocationContext } from "../../CustomHelper/Helper";
import {Waypoint} from "react-waypoint";



export default function GuestSingleLearningSession({ post }) {

  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const { countryDateTime } = useContext(LocationContext);
  const [isAvaiable,setSlot]=useState(true);

  const [data, setData] = useState({
    likes: post.react_number,
    updated: false,
  });
  let todayDate = new Date();
  let endDate = new Date(moment(post?.registration_end_date));

  const handleSubmit = (id) => {
    //e.preventDefault();
    if (!data.updated) {
      setData({ likes: data.likes + 1, updated: true });
    } else {
      setData({ likes: data.likes - 1, updated: false });
    }

    axios.get(`/api/submit_react/${id}`).then((res) => {
      if (res.data.status === 200) {
      } else {
        swal("Warning", "failed", "warning");
      }
    });
  };

  let [shouldPlay, updatePlayState] = useState(false);

  let handleEnterViewport = function () {
    updatePlayState(true);
  };
  let handleExitViewport = function () {
    updatePlayState(false);
  };

  useEffect(() => {
    // axios
    //   .get(`api/user/check-learning-session/slot/${post?.event_id}`)
    //   .then((res) => {
    //     if (res.data.status === 200) {
    //       setSlot(res.data.isAvailable);
    //     }
    //
    //   });
  }, []);


  return (
    <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
      <div className="card PostCardBg ">
        <h2 className="accordion-header PostBack">
          <div className="d-flex justify-content-between">
            <div className="accordion-button-fx profile1-accordion-button PostBack  collapsed">
              <img
                src={
                  post?.star?.image !== null
                    ? imageCdnUrl + post?.star?.image
                    : noImage
                }
                className="PostImgHome"
                alt="star-profile"
              />

              <span className="mx-2 text-warning text-light">
                <Link
                  to={`/starprofile/${post.user_id}`}
                  className="link-starPorfile"
                >
                  {post.star?.first_name} {post.star?.last_name}
                </Link>
                <br></br>
                <small className="category-size-chat">
                  {countryDateTime(post.created_at, "Do MMMM  YYYY, h:mm a")}

                </small>
                {/* <small className="category-size-chat">
                  {moment(post.created_at).format("LL")}
                </small> */}
              </span>
            </div>
          </div>
        </h2>

        <h5 className="my-2 Enroll-a Enroll-text text-justify">
          {post?.title}
        </h5>

        <ShowMoreText
          lines={3}
          more={<span>See more</span>}
          less={<span>See less</span>}
          className="content-css my-2 Enroll-a Enroll-text py-2"
          anchorClass="my-anchor-css-class"
          //onClick={executeOnClick}
          expanded={false}
          truncatedEndingComponent={"... "}
        >
          <Markup content={post?.details}></Markup>
        </ShowMoreText>
        <center className="post_new">
          {post?.video ? (
           <Waypoint scrollableAncestor='window' onEnter={handleEnterViewport} onLeave={handleExitViewport}>
            <div>
                  <ReactPlayer
                  url={videoCdnUrl + post?.video}
                  controls={true}
                  playing={shouldPlay}
                  volume={1}
                  className="Live-Video-x"
                  style={{ margin: "0 auto" }}
                />
            </div>
          </Waypoint>
          ) : (
            <img
              src={post?.banner !== null ? imageCdnUrl + post?.banner : noImage}
              alt={post?.banner}
            />
          )}
        </center>
        <div className="ViewPost">
          <div className=" card  border-0 containerPost">
            <div className="centeredPost ">
              <div className="LeftTextPost col-md-8">
                {post?.video ? (<div className=" text-light bottom-LeftPost text-start learning-session-text fw-bold px-4 py-1">Learning Session</div>):
                    (<div className=" text-light bottom-LeftPost text-start fw-bold px-4 py-1">Learning Session</div>)}
              </div>
              <div className="LeftTextPost col-md-4">
                {endDate.getTime() >= todayDate.getTime() && isAvaiable &&(
                  <Link
                    to={{
                      pathname: `/learning-session/details/${post.event_id}`,
                      state: { post: post },
                    }}
                    className="link-starPorfile"
                  >
                    <button className="bottom-rightPost text-dark fw-bold AnimateBtn px-4 py-1">
                      <span className="pTd"> Register Now</span>
                    </button>
                  </Link>
                ) }
              </div>
            </div>
            <div className="centeredPostV "></div>
          </div>

          <PostReaction post={post}></PostReaction>
        </div>
      </div>
    </div>
  );
}
